import { __assign } from "tslib";
export var createLinesApi = function (baseUrl, http) {
    var linesUrl = baseUrl + "/lines";
    var lineUrl = function (id) { return linesUrl + "/" + id; };
    var scheduleUrl = function (id) { return lineUrl(id) + "/schedule"; };
    var scheduleBusinessUrl = function (id) { return scheduleUrl(id) + "/businesshours"; };
    var findAvailablePhoneNumbersUrl = function (dto) {
        var params = dto.tollFree ? '?tollFree=true' : '';
        params += dto.areaCode ? (params ? '&' : '?') + "areaCode=" + dto.areaCode : '';
        params += dto.contains ? (params ? '&' : '?') + "contains=" + dto.contains : '';
        params += dto.limit ? (params ? '&' : '?') + "limit=" + dto.limit : '';
        params += dto.smsEnabled === undefined ? '' : (params ? '&' : '?') + "smsEnabled=" + dto.smsEnabled;
        return linesUrl + "/availablePhoneNumbers/" + dto.countryCode + params;
    };
    var scheduleOpeningHours = function (id) { return scheduleUrl(id) + "/openingHours"; };
    return {
        getLines: function () {
            return http.get(linesUrl);
        },
        getLineById: function (dto) {
            return http.get(lineUrl(dto.lineId));
        },
        getLinesByIVR: function (ivrDto) {
            return http.get(linesUrl + "/ivr?ivrId=" + ivrDto.id);
        },
        updateLineDetails: function (dto) {
            var payload = { name: dto.name, description: dto.description };
            return http.put(lineUrl(dto.lineId), payload);
        },
        deleteLine: function (dto) {
            return http.delete(lineUrl(dto.lineId));
        },
        getSchedule: function (dto) {
            return http.get(scheduleUrl(dto.lineId));
        },
        findAvailablePhoneNumbers: function (dto) {
            return http.get(findAvailablePhoneNumbersUrl(dto));
        },
        setScheduleBusinessHours: function (dto) {
            var payload = __assign({ applyToAllLines: dto.applyToAllLines, openTwentyFourSeven: dto.openTwentyFourSeven }, dto.dayData);
            return http.put(scheduleBusinessUrl(dto.lineId), payload);
        },
        setScheduleOpeningHours: function (dto) {
            return http.put(scheduleOpeningHours(dto.lineId), dto);
        },
        setScheduleDownTimes: function (dto) {
            var payload = { downTimes: dto.downTimes };
            return http.put(scheduleUrl(dto.lineId) + "/downtimes", payload);
        },
        setOffHoursVoiceMessage: function (dto) {
            return http.put(scheduleBusinessUrl(dto.lineId) + "/offHours/message/voice", { message: dto.inactiveLineVoiceMessage });
        },
        setOffHoursSmsMessage: function (dto) {
            return http.put(scheduleUrl(dto.lineId) + "/offHours/message/text", { message: dto.inactiveLineTextMessage });
        },
        setInbound: function (dto) {
            var payload = { enabled: dto.enabled, ivrId: dto.ivrId };
            return http.put(lineUrl(dto.lineId) + "/inbound", payload);
        },
        setOutbound: function (dto) {
            var payload = { enabled: dto.enabled };
            return http.put(lineUrl(dto.lineId) + "/outbound", payload);
        },
        setSmsInbound: function (dto) {
            var payload = { enabled: dto.enabled };
            return http.put(lineUrl(dto.lineId) + "/sms/inbound", payload);
        },
        setSmsOutbound: function (dto) {
            var payload = { enabled: dto.enabled };
            return http.put(lineUrl(dto.lineId) + "/sms/outbound", payload);
        },
        setInboundInactiveVoiceMessage: function (dto) {
            return http.put(lineUrl(dto.lineId) + "/inactiveLineVoiceMessage", { message: dto.inactiveLineVoiceMessage });
        },
        addLine: function (dto) {
            return http.post(linesUrl, dto);
        },
        setDefault: function (dto) {
            return http.put(lineUrl(dto.lineId) + "/setDefault", {});
        },
        setSmsDefault: function (dto) {
            return http.put(lineUrl(dto.lineId) + "/sms/setDefault", {});
        },
        lineDefaults: function () {
            return http.post(linesUrl + "/defaults", {});
        },
        getLinesStatus: function () {
            return http.get(linesUrl + "/status");
        },
        setLinesStatus: function (dto) {
            return http.put(linesUrl + "/status", dto);
        },
        setScheduleId: function (dto) {
            return http.put("" + scheduleUrl(dto.lineId), dto);
        },
        setAllLinesScheduleId: function (dto) {
            return http.put(linesUrl + "/schedule/all", dto);
        }
    };
};
//# sourceMappingURL=index.js.map